export enum ResetSmsMfaScreenNames {
  VERIFY_SMS_OTP = 'Verify OTP in MFA',
  SELECT_MFA = 'Select MFA',
  VERIFY_TOTP = 'Verify TOTP',
}

export const RESET_SMS_MFA_SCREEN_IDS = {
  VERIFY_SMS_OTP: 'SC33AgvexxJfWebcLazATrT1uNLbr',
  SELECT_MFA: 'SC33AgvgwWdwrNbCCkw2gUtrSKTSG',
  VERIFY_TOTP: 'SC33AgvjzjZ8gfRspCVIl2qlmpxvE',
};

export const RESET_SMS_MFA_INTERACTION_IDS = {
  SELECT_TOTP: '1glJiQSQMz',
  SELECT_SMS: 'kraHOXuK2J',
  SUBMIT_CODE: 'oneTimeCodeId',
  RESEND: 'resend',
};
